import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'solicitudes/quejas/';

export const getQuejas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return { results: [], count: 0 };
  }
};

export const getQueja = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

export const postQueja = async (data) => {
  try {
    const response = await API.post(baseURI, data);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

export const patchQueja = async (id, data, feedback = true) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, data);
    if (feedback) {
      onSuccess(response, 'Actualizado correctamente');
    }
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

export const deleteQueja = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
